import { ShieldCheck } from "lucide-react";

export function TMSEnrollCTA({ enrolled, onEnroll, checkingOut, price }) {
  if (enrolled) return null;
  return (
    <section data-testid="tms-bottom-cta-section" className="bg-[#1a0a0c] py-20 md:py-28 text-center">
      <div className="max-w-xl mx-auto px-6">
        <p className="text-xs uppercase tracking-[0.3em] text-[#c9962c] mb-5">Enrollment</p>
        <h2 className="font-display text-2xl md:text-4xl font-medium mb-5" style={{ color: "#f4ead9" }}>
          One enrollment. Lifetime access.
        </h2>
        <p className="text-white/60 mb-9">
          A single payment of <span className="font-meta">${price != null ? price : "497"}</span> unlocks
          all 106 lessons across all 7 Acts — forever, with progress and reflections saved to your account.
        </p>
        <button
          data-testid="tms-bottom-enroll-button"
          onClick={onEnroll}
          disabled={checkingOut}
          className="bg-[#c9962c] text-black px-8 py-4 text-sm uppercase tracking-wide font-medium hover:bg-[#e0ad3d] transition-colors duration-200 disabled:opacity-50"
        >
          {checkingOut ? "Redirecting…" : "Enroll in The Muscle School"}
        </button>
        <p className="text-xs text-white/40 flex items-center justify-center gap-1.5 mt-5">
          <ShieldCheck className="w-3.5 h-3.5 text-[#c9962c]" /> Secure checkout · Powered by Stripe
        </p>
      </div>
    </section>
  );
}
